import { adminApiFetch } from './apiService';

export const notificationService = {
  getRecords: async (params, type = 'unread') => { // type can be 'unread' or 'read'
    const scope = type === 'read' ? 'read' : undefined;
    const body = scope ? { ...params, scope } : params;
    const response = await adminApiFetch('notifications/get_records', {
      method: 'POST',
      body: JSON.stringify(body)
    });
    return response.json();
  },

  getIds: async (params, type = 'unread') => {
    const scope = type === 'read' ? 'read' : undefined;
    const body = scope ? { ...params, scope } : params;
    const response = await adminApiFetch('notifications/get_ids', {
      method: 'POST',
      body: JSON.stringify(body)
    });
    return response.json();
  },

  get: async (id) => {
    const response = await adminApiFetch(`notifications/${id}`);
    return response.json();
  },

  setRead: async (ids) => {
    const response = await adminApiFetch('notifications/set_read', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  },

  readAll: async () => {
    const response = await adminApiFetch('notifications/read_all', {
      method: 'POST',
    });
    return response.json();
  },

  getUnreadCount: async () => {
    const response = await adminApiFetch('notifications/unread_count');
    return response.json();
  },

  getNotifications: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page_size) queryParams.append('page_size', params.page_size);
    if (params.direction) queryParams.append('direction', params.direction);

    const response = await adminApiFetch(`notifications?${queryParams.toString()}`);
    return response.json();
  }
};
